import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy, signal } from '@angular/core'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { Projekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { ProjektitService } from '../../../_jaettu-angular/projektit.service'

interface ProjektiVarilla extends Projekti {
  varikoodi: string
  taustavari: string
}

@Component({
  selector: 'app-projekti-kentta',
  templateUrl: './projekti-kentta.component.html',
  styleUrls: ['./projekti-kentta.component.css'],
  providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProjektiKenttaComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe = new Subject<void>()

  @Input() valittuAvain = ''
  @Output() valittuAvainChange = new EventEmitter<string>()

  readonly pudotusvalikkoAuki = signal(false)
  readonly hakuteksti = signal('')
  readonly suodatetutProjektit = signal<ProjektiVarilla[]>([])

  private _kaikkiProjektit: ProjektiVarilla[] = []

  constructor(private _projektitService: ProjektitService) {}

  ngOnInit() {
    this._projektitService.naytettavatKirjanpitoprojektitObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(projektit => {
      this._kaikkiProjektit = projektit.map(p => ({
        ...p,
        ...this._projektitService.annaProjektinVarit(p.avain),
      }))
      if (this.valittuAvain) {
        const loytynyt = this._kaikkiProjektit.find(p => p.avain === this.valittuAvain)
        if (loytynyt) {
          this.hakuteksti.set(loytynyt.nimi)
        }
      }
      this._suodata()
    })
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  private _suodata() {
    const haku = this.hakuteksti().trim().toLowerCase()
    this.suodatetutProjektit.set(haku ? this._kaikkiProjektit.filter(p => p.nimi.toLowerCase().includes(haku)) : this._kaikkiProjektit)
  }

  suljePudotusvalikko() {
    setTimeout(() => {
      this.pudotusvalikkoAuki.set(false)
      this._palautaTekstiValintaan()
    }, 150)
  }

  private _palautaTekstiValintaan() {
    const valittu = this._kaikkiProjektit.find(p => p.avain === this.valittuAvain)
    this.hakuteksti.set(valittu ? valittu.nimi : '')
    this._suodata()
  }

  vaihdaTila(event: MouseEvent) {
    event.preventDefault()
    this.pudotusvalikkoAuki.update(auki => !auki)
    if (!this.pudotusvalikkoAuki()) {
      this._palautaTekstiValintaan()
    }
  }

  vaihdaTilaKentasta() {
    this.pudotusvalikkoAuki.update(auki => !auki)
  }

  valitseProjekti(p: ProjektiVarilla) {
    this.valittuAvain = p.avain
    this.hakuteksti.set(p.nimi)
    this.valittuAvainChange.emit(p.avain)
    this.pudotusvalikkoAuki.set(false)
    this._suodata()
  }

  tyhjenna() {
    this.valittuAvain = ''
    this.hakuteksti.set('')
    this.valittuAvainChange.emit('')
    this.pudotusvalikkoAuki.set(false)
    this._suodata()
  }

  paivitaHaku(arvo: string) {
    this.hakuteksti.set(arvo)
    this.pudotusvalikkoAuki.set(true)
    if (this.valittuAvain) {
      this.valittuAvain = ''
      this.valittuAvainChange.emit('')
    }
    this._suodata()
  }
}
